import * as DropdownMenuPrimitive from 'zeego/dropdown-menu';
import React from 'react';

// Direct exports of primitives - no wrapping needed for native menus
// Zeego will automatically use the native menu components on iOS/Android
const {
  Root,
  Trigger,
  Portal,
  Content,
  Item,
  ItemTitle,
  ItemIcon,
  CheckboxItem,
  RadioItem,
  Label,
  Separator,
  ItemIndicator,
  Arrow,
  Sub,
  SubTrigger,
  SubContent,
  RadioGroup,
  create,
} = DropdownMenuPrimitive;

const DropdownOverlayHost = DropdownMenuPrimitive.DropdownOverlayHost || null;
const DropdownBackground = DropdownMenuPrimitive.DropdownBackground || React.Fragment;

export {
  Root,
  Trigger,
  Portal,
  Content,
  Item,
  ItemTitle,
  ItemIcon,
  CheckboxItem,
  RadioItem,
  Label,
  Separator,
  ItemIndicator,
  Arrow,
  Sub,
  SubTrigger,
  SubContent,
  RadioGroup,
  DropdownOverlayHost,
  DropdownBackground,
  create
};
